import styled from 'styled-components'
import content from '../../../styles/_objects/content'

export const Container = styled.div`
  ${content} padding: 0;
`



// WEBPACK FOOTER //
// ./src/app/modules/ContestationForm/styles.js